export default __webpack_public_path__ + "static/apple-silicon-d4b63196535f5829e8d621f7cee5c9e7.png";